// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2T3PI","tabs":"LayoutWrapperSideNav_tabs__YvkMJ","tab":"LayoutWrapperSideNav_tab__1tkUB"};